var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:{
    'width-1180 main-container pr-5 pl-5 pb-16': true,
    'mt-desktop': !_vm.$vuetify.breakpoint.mobile,
    'mt-mobile': _vm.$vuetify.breakpoint.mobile
  }},[_c('RouterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }